import { render, staticRenderFns } from "./ModalUpdateContact.vue?vue&type=template&id=79e0cfeb&"
import script from "./ModalUpdateContact.vue?vue&type=script&lang=js&"
export * from "./ModalUpdateContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports